import Layout from '@/layout'
const route = {
  path: '/tiktok',
  component: Layout,
  redirect: '/tiktok',
  alwaysShow: true,
  name: 'tiktok',
  meta: {
    title: '抖音',
    icon: 'tiktok',
    roles: [
      'tiktok'
    ]
  },
  children: [
    {
      path: '/tiktok/novelLink/index',
      component: () => import('@/views/tiktokLink/index.vue'),
      name: 'TiktokLink',
      meta: {
        title: '小说链接',
        roles: [
          'tiktok.novelLink'
        ]
      }
    }
  ]
}

export default route
